import React, { useState, useRef, useEffect } from 'react';
import { Row, Col, Space, Popover, Badge } from 'antd';
import { Button } from 'witmeg-ui-system'
import { useSelector, useDispatch } from "react-redux";
import axios from 'axios';
import _ from "lodash";
import "@fontsource/inter";
import "@fontsource/jost";
import config from "react-global-configuration";
import './Navbar.scss';
import { useHistory } from 'react-router-dom';
import { getCompanyAllPagesInfo, updateOrderTypeDetails } from '../../../RestaurantWidget/utilities/api/restaurantsService';
import profile from "../../assets/solar_user-outline.svg"
import arrow from "../../assets/down-arrow.svg"
import menu from "../../assets/menu.svg"
import search from "../../assets/search-normal.svg"
import searchIc from "../../assets/search.svg"
import close from "../../assets/close.svg"
import loc from "../../assets/location-black.svg"
import IMAGE_PLACEHOLDER from "../../assets/images/Images/empty-placeholder.png"

import { getAllData, setOrderData, setSelectedOrderType } from '../../../../../../../redux/resturantWidgetSlice';
import { isECommerceProcessPath, LOCAL_STORAGE_ITEMS_NAMES, setLocalStorageData } from '../../../RestaurantWidget/utilities/helper/helper';
import CartPopup from '../Cart/CartPopup';
const Navbar = ({ setIsDrawerOpen, setAddDeliveryLoc, setCheckoutFailed, isStoreOpen, setIsStoreClosed }) => {
    const availableTypes = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).orderTypes

    const orderTypes = [
        { name: "Collection", type: "collection", typeValue: "TAKE_AWAY" },
        // { name: "Dine-in", type: "table", typeValue: "DINE_IN" },
        { name: "Delivery", type: "delivery", typeValue: "DELIVERY_BY_REWARDCONSUMER" },

    ]
    const filteredData = orderTypes.filter(item => availableTypes?.includes(item.type));

    const dispatch = useDispatch()
    const { selectedOrderType } = useSelector((state) => state.resturantData);
    const [data, setData] = useState([])

    const [searchKey, setSearchKey] = useState('')
    const [items, setItems] = useState([])
    const history = useHistory()
    const [state, setState] = useState({
        menusize: 0,
        menus: "",
        pages: [],
        categories: [],
        brands: [],
        basketitem: [],
        // hasResturantWidget: null,
        cloudLocations: [],
        locationsDropdown: [],
        selectedLocation: {},
        visibleCartSummaryPopup: false,
        showDropdown: false,
        redirect: false,
        activeDropdown: null,

        locations: [],
        defaultLocation: {},

        updateCartItemPopup: {
            visible: false,
            data: null,
            index: null,
            editData: null,
        },
    });
    const customerDetails = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS)) : {}


    const restaurantDataState = useSelector((state) => state.resturantData);
    const companyDataState = useSelector((state) => state.companyData);
    const resize = () => {
        if (window.innerWidth > 1681) {
            setState((prevState) => ({ ...prevState, menusize: 5 }));
        } else if (window.innerWidth < 1400 && window.innerWidth > 1150) {
            setState((prevState) => ({ ...prevState, menusize: 2 }));
        } else {
            setState((prevState) => ({ ...prevState, menusize: 3 }));
        }
    };
    const [isOpen, setIsOpen] = useState(false);
    const popoverRef = useRef(null);
    const containerRef = useRef(null);
    useEffect(() => {
        fetchDBData()
    }, []);
    const fetchDBData = async () => {
        await getAllData().then((result) => {
            setData(result?.data);
            if (result?.data && result?.data?.Categories && result?.data?.Categories?.length > 0) {
                let array = result?.data.Categories.map((val) => {
                    return val.MenuEntities.map((menuEntity) => {
                        const menuItem = _.find(data.Items, { MenuItemID: menuEntity.ID });
                        return { ...menuItem, Category: val.Title.en };
                    });
                }).flat();

                setItems(array)
            }
        });
    }
    const togglePopover = () => {
        setIsOpen(!isOpen);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setSearchKey("");
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const handleClickOutside = (event) => {
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(() => {
        window.addEventListener("resize", resize);
        resize();

        const _initData = async () => {
            const __response = await getCompanyAllPagesInfo({
                ID: "",
                CompanyID: config.get("companyID"),
            });

            let __pages = __response
                .filter((z) => z.DraftMainPagesInfoID === "")
                .map((y) => {
                    return {
                        ...y,
                        children: __response.filter(
                            (a) => a.DraftMainPagesInfoID === y.ID
                        ),
                    };
                });
            setState((prevState) => ({ ...prevState, pages: __pages }));
        };
        _initData();
    }, []);



    useEffect(() => {
        if (
            restaurantDataState.resturantCloudLocations &&
            restaurantDataState.resturantCloudLocations.length > 0 &&
            restaurantDataState.defualtSelectedLocation
        ) {
            const _locations = restaurantDataState.resturantCloudLocations.map(
                (__location) => ({
                    label: __location.CloudLocationName,
                    value: __location.CloudLocationID,
                })
            );

            const _defaultLocation = _.find(_locations, {
                value: restaurantDataState.defualtSelectedLocation
                    .CloudLocationID,
            });

            setState((prevState) => ({
                ...prevState,
                locations: _locations,
                defaultLocation: _defaultLocation,
                selectedLocation: _defaultLocation,
            }));
        }
    }, [
        restaurantDataState.resturantCloudLocations,
        restaurantDataState.defualtSelectedLocation,
    ]);

    useEffect(() => {
        if (companyDataState && companyDataState.companyDetails && companyDataState.companyDetails.organizationID) {
            axios.post(process.env.REACT_APP_TOKENSERVICE_URL, {
                isLoginServerRequest: false,
                serviceName: "productRegistry",
            }).then(async function (authresponse) {
                console.log("TOKEN response", authresponse)
                const requestOptions = {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authresponse.data.token}`,
                    }
                };

                let OrgID = companyDataState.companyDetails.organizationID

                axios.get(`${process.env.REACT_APP_rest_API_productregistry}/onlinecategories/${OrgID}`, requestOptions).then((categoryData) => {
                    if (categoryData.data.Status) {
                        console.log(categoryData.data.Result)
                    }
                })
            })
        }
    }, [companyDataState.companyDetails])

    useEffect(() => {
        if (data?.Categories && data?.Categories?.length > 0) {
            let array = data?.Categories.map((val) => {
                return val.MenuEntities.map((menuEntity) => {
                    const menuItem = _.find(data.Items, { MenuItemID: menuEntity.ID });
                    return { ...menuItem, Category: val.Title.en };
                });
            }).flat();

            setItems(array)
        }
    }, [searchKey])
    const searchedItems = (searchingValue) => {
        return items.filter(item => item.Title && item.Title.en && item.Title.en.toLowerCase().includes(searchingValue.toLowerCase()));
    }
    const toggleCartSummaryPopover = () => {
        setState((prevState) => ({
            ...prevState,
            visibleCartSummaryPopup: !prevState.visibleCartSummaryPopup,
        }));
    };

    const changeUpdateCartItemPopupVisibility = (_visible, _data = null) => {
        if (_visible) {
            setState((prevState) => ({
                ...prevState,
                updateCartItemPopup: {
                    visible: true,
                    data: _data.data,
                    editData: _data.editData,
                    index: _data.index,
                },
            }));
            toggleCartSummaryPopover();
        } else {
            setState((prevState) => ({
                ...prevState,
                updateCartItemPopup: {
                    visible: false,
                    data: null,
                    editData: null,
                    index: null,
                },
            }));
        }
    };



    const handleLogout = () => {
        sessionStorage.clear()
        localStorage.clear()
        window.location.href = '/'
    };
    const updateOrderType = (type) => {
        let body = {
            "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID),
            "DeliveryType": type,
            "CountryCode": "GB"
        }
        updateOrderTypeDetails(body).then((res) => {
            dispatch(setOrderData(res))
        })

    }

    return (
        <div className='Hospitality-navbar-Menu'>
            <div className="Hospitality-navbar-fixed-header">
                <Row align="middle">
                    <Col xs={5} className='Hospitality-navbar-menu-logo'>
                        <img
                            className="menu-icon-cont"
                            src={menu}
                            alt="Menu Icon"
                            onClick={() => {
                                if (window.screen.width > 600) {
                                    togglePopover()
                                } else {
                                    setIsDrawerOpen(true)
                                }
                            }}
                            style={{ cursor: 'pointer' }}
                        />
                        <div className="popover" ref={popoverRef}>
                            {isOpen ? <div className={`popover-content`}>
                                <div className='track-order-ntag' onClick={() => {
                                    history.push("/")
                                    setIsOpen(false)
                                }}>Menu</div>
                                {!isECommerceProcessPath() &&
                                    state.pages.map((pn, index) => (
                                        <>
                                            {pn.children.length === 0 &&
                                                pn.ShowInMainMenu === true && (
                                                    <div key={index} className='track-order-ntag' onClick={() => {
                                                        history.push(`/pages/${pn.Slug}`)
                                                        setIsOpen(false)
                                                    }}>{pn.PageName}</div>

                                                )}
                                        </>
                                    ))
                                }
                                <div className='track-order-ntag' onClick={() => {
                                    history.push("/order/track")
                                    setIsOpen(false)
                                }}>Track your Order</div>
                                {localStorage.getItem('isLogged') === 'true' && <div className='track-order-ntag' onClick={() => {
                                    history.push("/order/history")
                                    setIsOpen(false)
                                }}>Order history</div>}

                            </div> : <div className='popover-content-close' />}
                        </div>
                        {/* <Drawer /> */}

                        <div className="Hospitality-navbar-logo">

                            <a
                                className="eco-navbar-logo"
                                href={!restaurantDataState.hasResturantWidget && `/`}
                            >
                                <img
                                    style={{ maxHeight: "48px" }}
                                    src={config.get("companyLogo")}
                                    draggable="false"
                                />
                            </a>
                        </div>
                        <Space className='Hospitality-navbar-menu-tab'>
                            <a href="/" style={{ color: "white" }}>Menu</a>
                            {!isECommerceProcessPath() &&
                                state.pages.map((pn, index) => (
                                    <>
                                        {pn.children.length === 0 &&
                                            pn.ShowInMainMenu === true && (
                                                <a
                                                    href={`/pages/${pn.Slug}`}
                                                    style={{ color: "white" }}
                                                >
                                                    {pn.PageName}
                                                </a>
                                            )}
                                    </>
                                ))
                            }
                        </Space>
                    </Col>

                    <Col xs={14} className='Hospitality-navbar-menu'>


                        {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) ? "" : selectedOrderType !== "table" && <Space className='Hospitality-navbar-menu-tab-right'>
                            {filteredData.map((orderType, index) => {
                                return (
                                    <div key={index} className={`Hospitality-navbar-menu-order-type ${selectedOrderType === orderType.type ? "Hospitality-navbar-menu-order-type-selected" : ""} `} onClick={async () => {

                                        if (orderType.type === "delivery") {
                                            setAddDeliveryLoc(true)
                                        } else {
                                            const customerFormData = {
                                                ID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                                                Name: {
                                                    DisplayName: "",
                                                    FirstName: "",
                                                    LastName: "",
                                                },
                                                Email: "",
                                                Contact: {
                                                    Number: "",
                                                    PinCode: "+44",
                                                    CountryISO2: "GB"
                                                },
                                                BillingAddress: {
                                                    Id: "",
                                                    AddressType: "",
                                                    AddressLine1: "",
                                                    AddressLine2: "",
                                                    StateProvinceRegion: "",
                                                    PostZipCode: "",
                                                    Country: "",
                                                    CountryCode: "",
                                                    AddressLabel: "",
                                                    Longitude: 0,
                                                    Latitude: 0,
                                                    Additional: {
                                                        Instruction: "",
                                                        InteractionType: ""
                                                    }
                                                },
                                                DeliveryAddress: {
                                                    Id: "",
                                                    AddressType: "",
                                                    "AddressLine1": "",
                                                    "AddressLine2": "",
                                                    "City": "",
                                                    "StateProvinceRegion": "",
                                                    "PostZipCode": "",
                                                    "Country": "",
                                                    CountryCode: "",
                                                    AddressLabel: "",
                                                    Longitude: 0,
                                                    Latitude: 0,
                                                    Additional: {
                                                        Instruction: "",
                                                        InteractionType: ""
                                                    }
                                                },
                                            };
                                            let data = {
                                                "UserID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                                                "CompanyName": "",
                                                "UserName": "",
                                                "FirstName": "",
                                                "LastName": "",
                                                "Addresses": [
                                                    {
                                                        "AddressType": "Billing",
                                                        "HouseNo": "",
                                                        "AddressLine1": "",
                                                        "AddressLine2": "",
                                                        "City": "",
                                                        "StateProvinceRegion": "",
                                                        "PostZipCode": "",
                                                        "Country": "",
                                                        "Phone": "",
                                                        "Fax": "",
                                                        "Email": "",
                                                        "CreatedDate": "",
                                                        "LastModifiedDate": "",
                                                        "IsDefault": false,
                                                        "IsActive": false,
                                                        "TelephoneCode": "+44",
                                                        "AddressLabel": ""
                                                    },
                                                    {
                                                        "AddressType": "Delivery",
                                                        "HouseNo": "",
                                                        "AddressLine1": "",
                                                        "AddressLine2": "",
                                                        "City": "",
                                                        "StateProvinceRegion": "",
                                                        "PostZipCode": "",
                                                        "Country": "",
                                                        "Phone": "",
                                                        "Fax": "",
                                                        "Email": "",
                                                        "CreatedDate": "",
                                                        "LastModifiedDate": "",
                                                        "IsDefault": false,
                                                        "IsActive": false,
                                                        "TelephoneCode": "+44",
                                                        "AddressLabel": ""
                                                    }
                                                ],
                                                "Email": "",
                                            }
                                            localStorage.removeItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_LOC_ID)
                                            localStorage.setItem("fullUserDetails", JSON.stringify(data))
                                            await setLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS, customerFormData);
                                            dispatch(setSelectedOrderType(orderType.type))
                                            updateOrderType(orderType.typeValue)
                                        }


                                    }}>
                                        <div className={`menu-order-type-radio ${selectedOrderType === orderType.type ? "menu-order-type-radio-selected" : ""}`} >
                                            {selectedOrderType === orderType.type && <div className='menu-order-type-selected' />}
                                        </div>
                                        {orderType.name}</div>
                                )
                            })}
                            {selectedOrderType === "delivery" && <div className='location-delivery'
                                onClick={() => {
                                    setAddDeliveryLoc(true)
                                }}>
                                <img alt='' src={loc} />{customerDetails?.DeliveryAddress?.City}</div>}
                        </Space>}

                        {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) ?
                            "" : <div className='search-wrapper-cont' ref={containerRef} >
                                <div className='search-container'>
                                    <img alt='' src={search} className='search-image' />
                                    <input className='search-input' placeholder='search' value={searchKey} onChange={e => { setSearchKey(e.target.value) }} />
                                    {searchKey !== "" && < img alt='' src={close} className='close-image' onClick={() => { setSearchKey("") }} />}
                                </div>
                                {searchKey !== "" &&
                                    <div className='searched-container'>
                                        {searchedItems(searchKey).length > 0 ? searchedItems(searchKey).map((value, index) => {
                                            return (
                                                <div key={index} className='searched-item-cont' onClick={() => {
                                                    localStorage.removeItem("QUANTITY")
                                                    localStorage.removeItem("MODQUANTITY")
                                                    localStorage.removeItem("ITEM")
                                                    history.push('/item/' + value.MenuItemID + "/" + "new")
                                                    setSearchKey("")
                                                }}>
                                                    <img style={{ objectFit: !value.ImageURL ? "fill" : "" }} alt='' className='searched-image-cont' src={value.ImageURL ? value.ImageURL : IMAGE_PLACEHOLDER} />
                                                    <div className='items-cont'>
                                                        <div className='searched-title'>
                                                            {value.Title.en}</div>
                                                        <div className='searched-cat'>{value.Category}</div></div></div>
                                            )
                                        }) : <div className='empty-search'>No results found for <b>{searchKey}</b></div>}</div>}
                            </div>
                        }
                    </Col>
                    <Col xs={5} className='Hospitality-navbar-user-prof'>
                        <Row>
                            <Col>
                                <Row align="middle">

                                    <Col className='Hospitality-navbar-sign-in-menu'>

                                        <div className='Hospitality-navbar-sign-in-menu-icon'>
                                            <img alt='' src={profile} className='Hospitality-navbar-sign-in-menu-icon-profile' />
                                        </div>
                                        <div>
                                            {localStorage.getItem('isLogged') === 'true' ?
                                                < >
                                                    <div className='my-account-text'>{JSON.parse(localStorage.getItem('fullUserDetails')).FirstName} {JSON.parse(localStorage.getItem('fullUserDetails')).LastName}</div>
                                                    <div className='log-text' onClick={handleLogout} style={{ cursor: "pointer" }}>Logout</div>
                                                </>
                                                :
                                                <>
                                                    <div className='my-account-text'>MY ACCOUNT</div>
                                                    <div className='log-text'>
                                                        <a href="/account/login" >Login</a>
                                                        <div className='border-line-sign' />
                                                        <a href="/account/register">Signup</a>
                                                    </div>
                                                </>

                                            }
                                        </div>

                                    </Col>
                                </Row>
                            </Col>

                            <Col className='Hospitality-navbar-order'>

                                {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) ? "" : < img className='searchIC' src={searchIc} onClick={() => {
                                    history.push("/item/search")
                                }} />}
                                {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) ? "" :

                                    <Badge
                                        className="eco-navbar-toggle"
                                        count={
                                            restaurantDataState.cartDetails &&
                                                restaurantDataState.cartDetails.items
                                                ? restaurantDataState.cartDetails
                                                    .items.length
                                                : 100
                                        }
                                        size="small"
                                        overflowCount={99}
                                        style={{ transform: "translate(5%, -27%)", height: '18px', width: '18px' }}
                                    >
                                        <Popover
                                            content={
                                                <CartPopup
                                                    toggleVisibility={
                                                        toggleCartSummaryPopover
                                                    }
                                                    updateCartItemCallback={
                                                        changeUpdateCartItemPopupVisibility
                                                    }
                                                    websiteType={companyDataState.companyDetails.websiteType}
                                                    setCheckoutFailed={setCheckoutFailed}
                                                    isStoreOpen={isStoreOpen}
                                                    setIsStoreClosed={setIsStoreClosed}
                                                />
                                            }
                                            trigger="click"
                                            placement="bottomRight"
                                            visible={state.visibleCartSummaryPopup}
                                            onVisibleChange={() => {
                                                if (
                                                    state.visibleCartSummaryPopup ===
                                                    true
                                                ) {
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        visibleCartSummaryPopup: false,
                                                    }));
                                                }
                                            }}
                                            overlayClassName="eco-order-summary eco-cart-summary"
                                        >
                                            <div className='Hospitality-navbar-cart-nav-item'>

                                                <div className='Hospitality-navbar-cart-icon' onClick={toggleCartSummaryPopover} >
                                                    <Button
                                                        category="icon"
                                                        variant="link"
                                                        children="cart"
                                                        color="white"

                                                    />
                                                    {restaurantDataState?.orderCartData?.Items && restaurantDataState?.orderCartData?.Items?.length > 0 && < div className='Hospitality-navbar-noti-item'>{restaurantDataState?.orderCartData?.Items?.length}</div>}
                                                </div>
                                                <div className='Hospitality-navbar-history-icon' onClick={() => {
                                                    // history.push("/order/track")
                                                }}><img alt='' src={arrow} className='Hospitality-navbar-history' /></div>

                                            </div>
                                        </Popover>
                                    </Badge>

                                }
                            </Col>
                        </Row>

                    </Col>
                </Row>

            </div >
            <div className='mob-order-selection'>
                {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) ? "" : selectedOrderType !== "table" && <Space className='Hospitality-navbar-menu-mob'>
                    {filteredData.map((orderType, index) => {
                        return (
                            <div key={index} className={`Hospitality-navbar-menu-order-type-mob ${selectedOrderType === orderType.type ? "Hospitality-navbar-menu-order-type-mob-selected" : ""} `} onClick={async () => {

                                if (orderType.type === "delivery") {
                                    setAddDeliveryLoc(true)
                                } else {
                                    const customerFormData = {
                                        ID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                                        Name: {
                                            DisplayName: "",
                                            FirstName: "",
                                            LastName: "",
                                        },
                                        Email: "",
                                        Contact: {
                                            Number: "",
                                            PinCode: "+44",
                                            CountryISO2: "GB"
                                        },
                                        BillingAddress: {
                                            Id: "",
                                            AddressType: "",
                                            AddressLine1: "",
                                            AddressLine2: "",
                                            StateProvinceRegion: "",
                                            PostZipCode: "",
                                            Country: "",
                                            CountryCode: "",
                                            AddressLabel: "",
                                            Longitude: 0,
                                            Latitude: 0,
                                            Additional: {
                                                Instruction: "",
                                                InteractionType: ""
                                            }
                                        },
                                        DeliveryAddress: {
                                            Id: "",
                                            AddressType: "",
                                            "AddressLine1": "",
                                            "AddressLine2": "",
                                            "City": "",
                                            "StateProvinceRegion": "",
                                            "PostZipCode": "",
                                            "Country": "",
                                            CountryCode: "",
                                            AddressLabel: "",
                                            Longitude: 0,
                                            Latitude: 0,
                                            Additional: {
                                                Instruction: "",
                                                InteractionType: ""
                                            }
                                        },
                                    };
                                    let data = {
                                        "UserID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                                        "CompanyName": "",
                                        "UserName": "",
                                        "FirstName": "",
                                        "LastName": "",
                                        "Addresses": [
                                            {
                                                "AddressType": "Billing",
                                                "HouseNo": "",
                                                "AddressLine1": "",
                                                "AddressLine2": "",
                                                "City": "",
                                                "StateProvinceRegion": "",
                                                "PostZipCode": "",
                                                "Country": "",
                                                "Phone": "",
                                                "Fax": "",
                                                "Email": "",
                                                "CreatedDate": "",
                                                "LastModifiedDate": "",
                                                "IsDefault": false,
                                                "IsActive": false,
                                                "TelephoneCode": "+44",
                                                "AddressLabel": ""
                                            },
                                            {
                                                "AddressType": "Delivery",
                                                "HouseNo": "",
                                                "AddressLine1": "",
                                                "AddressLine2": "",
                                                "City": "",
                                                "StateProvinceRegion": "",
                                                "PostZipCode": "",
                                                "Country": "",
                                                "Phone": "",
                                                "Fax": "",
                                                "Email": "",
                                                "CreatedDate": "",
                                                "LastModifiedDate": "",
                                                "IsDefault": false,
                                                "IsActive": false,
                                                "TelephoneCode": "+44",
                                                "AddressLabel": ""
                                            }
                                        ],
                                        "Email": "",
                                    }
                                    localStorage.removeItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_LOC_ID)
                                    localStorage.setItem("fullUserDetails", JSON.stringify(data))
                                    await setLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS, customerFormData);
                                    dispatch(setSelectedOrderType(orderType.type))
                                    updateOrderType(orderType.typeValue)
                                }
                            }}>
                                {orderType.name}</div>
                        )
                    })}
                </Space>}
                {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) ? "" : selectedOrderType === "delivery" && <div className='location-delivery-mobile'
                    onClick={() => {
                        setAddDeliveryLoc(true)
                    }}>
                    <img alt='' src={loc} />{customerDetails?.DeliveryAddress?.City}</div>}
            </div>
        </div >
    );
};

export default Navbar;